import React, {Component, Fragment} from 'react'
import {connect} from 'react-redux'
import ReactSelect from "react-select";
import AsyncSelect from 'react-select/lib/Async';

import WithAjax from '../../../panel-admin/common/helpers/WithAjax'
import {getCountryDBcode} from '../../../panel-admin/common/functions/countrySetting'

class MultiSelectAutoCompleteCriteria extends Component {
  constructor(props){
    super(props);

    this.getSelectedOption = this.getSelectedOption.bind(this);
    this.getDataFromApiByInput = this.getDataFromApiByInput.bind(this);
    this.onSearch = this.onSearch.bind(this);

    this.timeout = 0;

    this.state = {
      data: [],
      userInput:'',
      inputValue: '',
      selectedValue: '',
      selectedValues: [],
      newArr:[],
      isLoading: false,
      labelsArr:''
    }
  }

  componentDidMount(){
    //solution for first click should show some records
    this.getDataFromApiByInput('a');
    if(this.props.option){
      this.setState({selectedValues:this.props.option});
    }
  }

  getSelectedOption(e){
    this.setState({
      userInput: e,
      selectedValues: e
    });
    var newArr = [];
    for(let i=0;i<e.length;i++){
      newArr.push(e[i].value);
    }
    this.props.getSelectedOption(e?newArr:'');
    return e;
  }

  getDataFromApiByInput(inputValue){
    let inputFieldValue;

    if(typeof inputValue === 'object'){
      inputFieldValue = 'a';
    }else{
      inputFieldValue = inputValue;
    }
    let profileType = this.props.field.rules.profileType;
    let profileTypeUrl = '';
    if(profileType){
      profileTypeUrl = '&ProfileType='+profileType;
    }

    let url = 'autocomplete/' + this.props.field.rules.url + '?Search=' + inputFieldValue + '&Skip=0&Take=' + getCountryDBcode() + profileTypeUrl;
    this.setState(
      {
        isLoading: true
      }
    );
    //call for labels
    if(this.props.option){
      let savedOption = this.props.option;
      let savedOptionArr = savedOption.split(",");
      let savedOptionTitlesByNumbers = [];
      savedOptionArr.map(item=>{
        let urlLabel = 'autocomplete/' + this.props.field.rules.url + '?Ids=' + item + '&Skip=0&Take=' + getCountryDBcode() + profileTypeUrl;
        this.props.ajax.get(urlLabel, true, (data) => {
          let options = [];
          data.Collection.map(item => {
            options.push({value: item.Id, label: item.Label});
          });
          savedOptionTitlesByNumbers.push(options[0]);
          this.setState(
            {
              //labelsArr:options[0],
              isLoading: false
            }
          );
        }, false, true);
      });
      this.setState(
        {
          labelsArr:savedOptionTitlesByNumbers,
          isLoading: false
        }
      );
    }


    this.props.ajax.get(url, true, (data) => {
      let options = [];
      data.Collection.map(item => {
        options.push({value: item.Id, label: item.Label});
      });
      //hack for option
      //options.push({value:507, label:'Million Dollar Extreme Presents: World Peace'});
      if(this.props.option){
        let labelsArr = this.state.labelsArr;

        labelsArr.map(item=>{
              options.push(item);
        })

      }

      //console.log(options);
      this.setState(
        {
          data:options,
          isLoading: false
        }
      );
    }, false, true);


  }

  onSearch(search){
    if(this.timeout) clearTimeout(this.timeout);
     this.timeout = setTimeout(() => {
       search();
     }, 1000);
  }

  getDataFromApiByIds(ids){
    let result = ids.includes(",");
    let idsArr = []
    let urlLabel = '';
    let idsString = '';
    let options = [];
    let profileType = this.props.field.rules.profileType;
    let profileTypeUrl = '';
    if(profileType){
      profileTypeUrl = '&ProfileType='+profileType;
    }
    if(result){
      idsArr = ids.split(',');
      for(let i=0;i<idsArr.length;i++){
        idsString += 'Ids='+idsArr[i]+'&';
      }
      urlLabel = 'autocomplete/' + this.props.field.rules.url + '?' +idsString + 'Skip=0&Take=' + getCountryDBcode() + profileTypeUrl;
    }else{
      urlLabel = 'autocomplete/' + this.props.field.rules.url + '?Ids=' + ids + '&Skip=0&Take=' + getCountryDBcode() + profileTypeUrl;
    }

    //let urlLabel = 'autocomplete/' + this.props.field.rules.url + '?Ids=' + ids + '&Skip=0&Take=' + getCountryDBcode() + profileTypeUrl;
    //let urlLabel = 'autocomplete/' + this.props.field.rules.url + '?Ids=374&Ids=158' + '&Skip=0&Take=' + getCountryDBcode() + profileTypeUrl;

    this.props.ajax.get(urlLabel, true, (data) => {
      // let options = [];
      data.Collection.map(item => {
        options.push({value: item.Id, label: item.Label});
      });

      this.setState(
        {
          data: options,
          //isLoading: false
        }
      );
    }, false, true);

  }


  componentWillReceiveProps(props) {
    if(props.clear){
        this.setState({ selectedValues: '' })
    }

    if(props.option && !props.clear){
        this.setState({ selectedValues: props.option })
        this.getDataFromApiByIds(props.option);

    }


  }


  render(){
    let field = this.props.field;
    let validate = this.props.validate;
    let search = this.props.search;

    field.value = this.state.selectedValues;


    //add labelsArr
      //console.log(this.state.labelsArr);
      // if(field.name == "ExternalExperience"){
      //   console.log(this.state.data);
      // }

    return(
      <div className="form-group">
        <label className="col-form-label col-form-label-sm">{field ? field.rules.title:''}</label>
        <ReactSelect
          placeholder={field.placeholder}
          autosize={true}
          multi
          autoFocus
          isLoading={this.state.isLoading}
          options = {this.state.data}
          clearable={true}
          name={field.name}
          value={field.value || ''}
          defaultValue={this.state.userInput}
          onFocus={this.getDataFromApiByInput}
          onInputChange={this.getDataFromApiByInput}
          onChange={
            value => {
              this.getSelectedOption(value);
              this.onSearch(search);
            }
          }
        />
      </div>
    )
  }

}

  const mapStateToProps = (state, ownProps) => ({
  })
  const mapDispatchToProps = dispatch => ({
  })
  export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(MultiSelectAutoCompleteCriteria))
